import { Component } from '@angular/core';

@Component({
    selector: 'follow-up',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class FollowUpComponent {}
